var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.alerts),function(a,index){return _c('v-alert',{key:index,attrs:{"type":a.type,"dense":"","dismissible":""}},[_vm._v(" "+_vm._s(a.message)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }